import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function FakeSleepPromise(ms?: number) {
  const msToSleep = ms ?? 1500;
  return new Promise((resolve, _reject) => {
    setTimeout(() => {
      resolve(1);
    }, msToSleep);
  });
}
